import React, { useState } from 'react';
import { toast } from 'sonner';
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { FileSpreadsheet, FileText, Printer } from 'lucide-react';
import { Button } from '../../components/Button';
import { PageHeader } from '../../components/common/PageHeader';
import { Panel } from '../../components/common/Panel';
import { NativeSelect } from '../../components/common/NativeSelect';
import { divisionRegistered, divisionVerification } from '../../data/dashboard';
import { trafficDivisions } from '../../data/cngs';
import { bnNum } from '../../utils/bn';
const reports = [{
  key: 'total',
  name: 'মোট নিবন্ধিত যানবাহন',
  value: '৪,৬৭,০০০',
  desc: 'সিএনজি, অটোরিকশা ও মোটরসাইকেল — ধরন ও বিভাগভিত্তিক'
}, {
  key: 'qrIssue',
  name: 'QR ইস্যু রিপোর্ট',
  value: '২,৮২,৫৫০',
  desc: 'ইস্যুকৃত, প্রিন্টকৃত ও অপেক্ষমাণ স্টিকার'
}, {
  key: 'qrScan',
  name: 'QR স্ক্যান রিপোর্ট',
  value: '৩০,৬৫৪',
  desc: 'গত ৭ দিনের রোডসাইড স্ক্যান'
}, {
  key: 'driver',
  name: 'চালক যাচাই রিপোর্ট',
  value: '৩৮,৪১২',
  desc: 'নিবন্ধিত ও যাচাইকৃত চালক'
}, {
  key: 'expLicense',
  name: 'মেয়াদোত্তীর্ণ লাইসেন্স',
  value: '৬১২',
  desc: 'মেয়াদ শেষ ও ৩০ দিনে শেষ হবে'
}, {
  key: 'expFitness',
  name: 'মেয়াদোত্তীর্ণ ফিটনেস',
  value: '২৮৪',
  desc: 'ফিটনেস নবায়ন প্রয়োজন'
}, {
  key: 'unauth',
  name: 'অননুমোদিত চালক',
  value: '১৪৯',
  desc: 'রোডসাইডে শনাক্ত (চলতি মাস)'
}, {
  key: 'irreg',
  name: 'অনিয়ম রিপোর্ট',
  value: '৩৭১',
  desc: 'ধরন ও নিষ্পত্তির অবস্থা'
}, {
  key: 'division',
  name: 'ট্রাফিক বিভাগভিত্তিক রিপোর্ট',
  value: '৮ বিভাগ',
  desc: 'বিভাগওয়ারি তুলনামূলক চিত্র'
}];
export function Reports() {
  const [active, setActive] = useState('division');
  const current = reports.find(r => r.key === active) ?? reports[0];
  return <div data-id="element-3367" data-mp="2llsi01ws5mh9">
      <PageHeader title="রিপোর্ট" subtitle="পরিচালনাগত ও ব্যবস্থাপনাগত রিপোর্ট — PDF, Excel ও প্রিন্ট" data-id="element-3368" data-mp="2llir8c3wvbai" />
      <div className="grid gap-3 sm:grid-cols-2 xl:grid-cols-3" data-id="element-3369" data-mp="2hjnpx7lzcxwq">
        {reports.map(r => <button key={r.key} onClick={() => setActive(r.key)} className={`rounded-lg border bg-white p-4 text-left shadow-sm ${active === r.key ? 'border-navy-600 ring-2 ring-navy-100' : 'border-border hover:border-navy-300'}`} data-id="element-3370" data-mp="2j0t30h26ckcr">
            <div className="flex items-start justify-between gap-2" data-id="element-3371" data-mp="292d966briwzk">
              <div className="flex items-start gap-3" data-id="element-3372" data-mp="2e1q6xm469ogx">
                <span className="flex h-9 w-9 items-center justify-center rounded-md bg-navy-50 text-navy-700" data-id="element-3373" data-mp="2e4cevmuz65zo"><FileText className="h-[18px] w-[18px]" data-id="element-3374" data-mp="209jt46ohrtkn" /></span>
                <div data-id="element-3375" data-mp="252mnui50992f">
                  <p className="font-semibold text-navy-900" data-id="element-3376" data-mp="2534gl4sgl55l">{r.name}</p>
                  <p className="text-xs text-slate-500" data-id="element-3377" data-mp="1qdq6tvkz0lpo">{r.desc}</p>
                </div>
              </div>
              <span className="font-heading text-lg font-bold text-navy-800" data-id="element-3378" data-mp="1vct9xahe4hv0">{r.value}</span>
            </div>
          </button>)}
      </div>

      <Panel className="mt-4" title={current.name} subtitle="সময়কাল: ০৬–১২ মার্চ ২০২৬ • নমুনা তথ্য" actions={<>
            <NativeSelect options={['সকল বিভাগ', ...trafficDivisions]} aria-label="বিভাগ" className="w-36" data-id="element-3380" data-mp="12ptn2fl1f887" />
            <NativeSelect options={['গত ৭ দিন', 'চলতি মাস', 'গত ৩ মাস', 'কাস্টম']} aria-label="সময়কাল" className="w-32" data-id="element-3381" data-mp="xs1letulc7qt" />
            <Button variant="outline" size="sm" onClick={() => toast.success(`${current.name}.pdf ডাউনলোড হচ্ছে`)} data-id="element-3382" data-mp="1bnlu6wglv9ki"><FileText className="h-4 w-4 text-red-600" data-id="element-3383" data-mp="16t8150pf1ej0" />PDF</Button>
            <Button variant="outline" size="sm" onClick={() => toast.success(`${current.name}.xlsx ডাউনলোড হচ্ছে`)} data-id="element-3384" data-mp="1lmkzq662qp3a"><FileSpreadsheet className="h-4 w-4 text-emerald-700" data-id="element-3385" data-mp="1got0er33o0p2" />Excel</Button>
            <Button variant="outline" size="sm" onClick={() => window.print()} data-id="element-3386" data-mp="1uf69wxvn3ngi"><Printer className="h-4 w-4" data-id="element-3387" data-mp="1qecku16go2m1" />Print</Button>
          </>} data-id="element-3379" data-mp="1ldkmz1ky03i5">
        <div className="grid gap-6 xl:grid-cols-[1fr_1fr]" data-id="element-3388" data-mp="24enefbz5nvaw">
          <div className="h-72" data-id="element-3389" data-mp="24ex3mxcdlyfj">
            <ResponsiveContainer data-id="element-3390" data-mp="1zfkjwlgsx7h6">
              <BarChart data={divisionVerification} margin={{
              left: -10
            }} data-id="element-3391" data-mp="1zglu6npztpxu">
                <CartesianGrid stroke="#eef1f5" vertical={false} data-id="element-3392" data-mp="2ji6wzj5576ji" />
                <XAxis dataKey="division" tick={{
                fontSize: 12
              }} axisLine={false} tickLine={false} data-id="element-3393" data-mp="2jfkn3cus4ey4" />
                <YAxis tick={{
                fontSize: 11
              }} axisLine={false} tickLine={false} data-id="element-3394" data-mp="2ngw792uvw7yx" />
                <Tooltip formatter={(v: number, n: string) => [bnNum(v), n === 'scans' ? 'স্ক্যান' : 'অনিয়ম']} data-id="element-3395" data-mp="2saqxyq8wpn7i" />
                <Bar dataKey="scans" fill="#0b2e5f" radius={[3, 3, 0, 0]} data-id="element-3396" data-mp="2xawjrpshwfho" />
                <Bar dataKey="issues" fill="#c62828" radius={[3, 3, 0, 0]} data-id="element-3397" data-mp="20kdughyfkymn" />
              </BarChart>
            </ResponsiveContainer>
          </div>
          <table className="w-full text-sm" data-id="element-3398" data-mp="29jr3j9in7l6u">
            <thead className="bg-slate-50 text-left text-xs text-slate-500" data-id="element-3399" data-mp="29hwjryj3xz4c">
              <tr data-id="element-3400" data-mp="2ejlufd2f4arw">{['ট্রাফিক বিভাগ', 'নিবন্ধিত যানবাহন', 'আজ স্ক্যান', 'অনিয়ম', 'অনিয়ম হার'].map(h => <th key={h} className="px-3 py-2 font-medium" data-id="element-3401" data-mp="3kzfq3zrzii74">{h}</th>)}</tr>
            </thead>
            <tbody data-id="element-3402" data-mp="3pwy3q3gy5llg">
              {divisionVerification.map((d, i) => <tr key={d.division} className="border-t border-border" data-id="element-3403" data-mp="1eae1u52ef963" data-mpi={i}>
                  <td className="px-3 py-2 font-medium" data-id="element-3404" data-mp="1ecgrgnzn30aa">ট্রাফিক-{d.division}</td>
                  <td className="px-3 py-2" data-id="element-3405" data-mp="19bt3ycamd1kt">{bnNum(divisionRegistered[i])}</td>
                  <td className="px-3 py-2" data-id="element-3406" data-mp="14jj526rj0r6e">{bnNum(d.scans)}</td>
                  <td className="px-3 py-2 text-red-700" data-id="element-3407" data-mp="zlhpvwx81c07">{bnNum(d.issues)}</td>
                  <td className="px-3 py-2" data-id="element-3408" data-mp="zjevz1sy6yq7">{bnNum(Number((d.issues / d.scans * 100).toFixed(1)))}%</td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </Panel>
    </div>;
}